import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Form, Label } from "semantic-ui-react";

const cleanNumbers = (ddiText: string) => {
  let txt = ddiText.match(/[0-9]{9,20}/g);
  if (txt != null && !isEmpty(txt)) {
    return txt
      .map((value) => {
        let s = value;
        if (s.startsWith("00")) s = value.substr(2);
        if (s.startsWith("0")) s = "44" + value.substr(1);
        return s;
      })
      .join("\n");
  }
  return "";
};

const CallableDDIInput = ({
  field,
  form: { errors, touched, setFieldValue },
  label,
  inline,
  ...props
}: any) => {
  const [newValue, setNewValue] = useState<string>(field.value);
  return (
    <Form.Field>
      {label && <label>{label}</label>}
      <input
        onChange={(e) => setNewValue(e.currentTarget.value)}
        onBlur={(e) => {
          const v = cleanNumbers(e.currentTarget.value);
          setNewValue(v);
          setFieldValue(field.name, v);
        }}
        name={field.name}
        value={newValue}
        {...props}
      />
      {touched[field.name] && errors[field.name] && (
        <Label basic pointing color='red'>
          {errors[field.name]}
        </Label>
      )}
    </Form.Field>
  );
};

export default CallableDDIInput;
